<template>
  <div class="navigation-dashboard">
    <!-- Header -->
    <header class="dashboard-header">
      <div class="header-content">
        <div class="logo-section">
          <div class="kpmg-logo" @click="navigateToHome">
            <img src="/kpmg-logo-blue.svg" alt="KPMG" class="kpmg-logo-img" />
          </div>
          <div class="product-info">
            <h1>K-IMPACT Platform</h1>
            <p>KPMG Infrastructure Management, Planning, and Assessment for Critical Transformation Platform Platform</p>
          </div>
        </div>
        <div class="user-section">
          <span class="user-name">Welcome, KPMG User</span>
          <button @click="logout" class="logout-btn">Logout</button>
        </div>
      </div>
    </header>

    <!-- Main Navigation -->
    <main class="main-content">
      <div class="container">
        <!-- Dashboard Stats -->
        <section class="stats-section">
          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon">📊</div>
              <div class="stat-content">
                <h3>{{ dashboardStats.projects }}</h3>
                <p>No. of Projects</p>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">🏛️</div>
              <div class="stat-content">
                <h3>{{ dashboardStats.agencies }}</h3>
                <p>No. of Implementing Government Agencies</p>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">💰</div>
              <div class="stat-content">
                <h3>${{ dashboardStats.totalValue }}</h3>
                <p>Total Value (USD)</p>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">🏗️</div>
              <div class="stat-content">
                <h3>{{ dashboardStats.sectors }}</h3>
                <p>No. of Sectors</p>
              </div>
            </div>
          </div>
        </section>

        <!-- Main Functions -->
        <section class="functions-section">
          <h2 class="section-title">Project Management Functions</h2>
          <div class="functions-grid">
            
            <!-- Create New Project -->
            <div class="function-card primary" @click="createNewProject">
              <div class="function-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L12 22M2 12L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
              <h3>Create New Project</h3>
              <p>Start a comprehensive assessment for a new PPP infrastructure project</p>
              <div class="function-action">
                <span>Get Started →</span>
              </div>
            </div>

            <!-- Edit Existing Project -->
            <div class="function-card" @click="editExistingProject">
              <div class="function-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" stroke-width="2"/>
                  <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <h3>Edit Existing Project</h3>
              <p>Modify and update assessment data for existing projects</p>
              <div class="function-action">
                <span>Select Project →</span>
              </div>
            </div>

            <!-- Project Dashboard -->
            <div class="function-card" @click="openProjectDashboard">
              <div class="function-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <h3>Project Assessment Dashboard</h3>
              <p>View detailed analysis and scoring for individual projects</p>
              <div class="function-action">
                <span>View Dashboard →</span>
              </div>
            </div>

            <!-- Pipeline Analytics -->
            <div class="function-card" @click="openPipelineAnalytics">
              <div class="function-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M3 3v18h18" stroke="currentColor" stroke-width="2"/>
                  <path d="m19 9-5 5-4-4-3 3" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <h3>Pipeline Analytics</h3>
              <p>Compare and analyze multiple projects for strategic prioritization</p>
              <div class="function-action">
                <span>Analyze →</span>
              </div>
            </div>

            <!-- Report Generator -->
            <div class="function-card" @click="openReportGenerator">
              <div class="function-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" stroke="currentColor" stroke-width="2"/>
                  <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2"/>
                  <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
                  <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <h3>Report Generator</h3>
              <p>Generate comprehensive assessment reports and download detailed analysis</p>
              <div class="function-action">
                <span>Generate →</span>
              </div>
            </div>

          </div>
        </section>

        <!-- Recent Projects -->
        <section class="recent-projects">
          <div class="section-header">
            <h2>Recent Projects</h2>
            <button @click="viewAllProjects" class="view-all-btn">View All</button>
          </div>
          <div class="projects-table">
            <div class="table-header">
              <span>Project Name</span>
              <span>Sector</span>
              <span>Stage</span>
              <span>Last Updated</span>
              <span>Score</span>
              <span>Actions</span>
            </div>
            <div v-for="project in recentProjects" :key="project.id" class="table-row">
              <span class="project-name">{{ project.name }}</span>
              <span class="sector">{{ project.sector }}</span>
              <span :class="['stage', project.stage.toLowerCase().replace(/\s+/g, '-')]">{{ project.stage }}</span>
              <span class="date">{{ project.lastUpdated }}</span>
              <span class="score">{{ project.score }}/100</span>
              <div class="actions">
                <button @click="editProject(project.id)" class="action-btn edit">Edit</button>
                <button @click="viewProject(project.id)" class="action-btn view">View</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'NavigationDashboard',
  data() {
    return {
      dashboardStats: {
        projects: 24,
        agencies: 8,
        totalValue: '3.2B',
        sectors: 6
      },
      recentProjects: [
        {
          id: 1,
          name: 'Metro Line Extension Project',
          sector: 'Transport',
          stage: 'Implementation',
          lastUpdated: '2024-01-15',
          score: 78,
          totalCost: 450,
          implementingAgency: 'Department of Transportation',
          timeline: 48,
          fundingSource: 'PPP'
        },
        {
          id: 2,
          name: 'Water Treatment Facility',
          sector: 'Water',
          stage: 'Feasibility',
          lastUpdated: '2024-01-10',
          score: 85,
          totalCost: 280,
          implementingAgency: 'Ministry of Water Resources',
          timeline: 36,
          fundingSource: 'Government Budget'
        },
        {
          id: 3,
          name: 'Solar Power Plant',
          sector: 'Energy',
          stage: 'Concept',
          lastUpdated: '2024-01-08',
          score: 72,
          totalCost: 320,
          implementingAgency: 'Ministry of Energy',
          timeline: 42,
          fundingSource: 'International Loan'
        },
        {
          id: 4,
          name: 'Hospital Infrastructure',
          sector: 'Health',
          stage: 'Pre-feasibility',
          lastUpdated: '2024-01-05',
          score: 68,
          totalCost: 180,
          implementingAgency: 'Ministry of Health',
          timeline: 30,
          fundingSource: 'Grant'
        },
        {
          id: 5,
          name: 'Smart City Initiative',
          sector: 'Urban infrastructure',
          stage: 'Procurement',
          lastUpdated: '2024-01-03',
          score: 81,
          totalCost: 520,
          implementingAgency: 'Ministry of Urban Development',
          timeline: 60,
          fundingSource: 'PPP'
        }
      ]
    }
  },
  methods: {
    createNewProject() {
      this.$emit('navigate', 'create-project')
    },
    editExistingProject() {
      this.$emit('navigate', 'project-list')
    },
    openProjectDashboard() {
      this.$emit('navigate', 'project-dashboard')
    },
    openPipelineAnalytics() {
      this.$emit('navigate', 'pipeline-analytics')
    },
    openReportGenerator() {
      this.$emit('navigate', 'report-generator')
    },
    editProject(projectId) {
      this.$emit('navigate', 'edit-project', { projectId })
    },
    viewProject(projectId) {
      this.$emit('navigate', 'view-project', { projectId })
    },
    viewAllProjects() {
      this.$emit('navigate', 'project-list')
    },
    logout() {
      this.$emit('navigate', 'landing')
    },
    navigateToHome() {
      this.$emit('navigate', 'landing')
    }
  }
}
</script>

<style scoped>
.navigation-dashboard {
  min-height: 100vh;
  background: rgb(229, 229, 229);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */
.dashboard-header {
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.kpmg-logo {
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.kpmg-logo:hover {
  transform: scale(1.05);
}

.kpmg-logo-img {
  height: 32px;
  width: auto;
}

.product-info h1 {
  font-size: 1.1rem;
  color: rgb(51, 51, 51);
  margin: 0;
  font-weight: 600;
}

.product-info p {
  font-size: 0.9rem;
  color: rgb(102, 102, 102);
  margin: 0;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-name {
  color: rgb(102, 102, 102);
  font-weight: 500;
}

.logout-btn {
  background: transparent;
  color: rgb(0, 51, 141);
  border: 1px solid #00338d;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.logout-btn:hover {
  background: rgb(0, 51, 141);
  color: white;
}

/* Main Content */
.main-content {
  padding: 2rem 0;
}


.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Stats Section */
.stats-section {
  margin-bottom: 3rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.stat-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: transform 0.3s, box-shadow 0.3s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.12);
}

.stat-icon {
  font-size: 2.5rem;
  opacity: 0.8;
}

.stat-content h3 {
  font-size: 2rem;
  color: rgb(0, 51, 141);
  margin: 0;
  font-weight: 700;
}

.stat-content p {
  color: rgb(102, 102, 102);
  margin: 0;
  font-weight: 500;
}

/* Functions Section */
.functions-section {
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2rem;
  color: rgb(51, 51, 51);
  margin-bottom: 2rem;
  font-weight: 600;
}

.functions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.function-card {
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: all 0.4s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  transform: translateY(0);
}

.function-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, rgb(0, 51, 141), rgb(30, 73, 226));
  opacity: 0;
  transition: all 0.4s ease;
}

.function-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 51, 141, 0.05), transparent);
  transition: left 0.6s ease;
}

.function-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 50px rgba(0, 51, 141, 0.15);
  border-color: rgb(0, 51, 141);
  background: linear-gradient(135deg, white, rgb(248, 250, 255));
}

.function-card:hover::after {
  left: 100%;
}

.function-card:hover::before {
  opacity: 1;
  height: 6px;
}

.function-card.primary {
  background: linear-gradient(135deg, rgb(0, 51, 141), rgb(30, 73, 226));
  color: white;
  box-shadow: 0 6px 20px rgba(0, 51, 141, 0.3);
}

.function-card.primary:hover {
  transform: translateY(-10px) scale(1.03);
  box-shadow: 0 25px 60px rgba(0, 51, 141, 0.4);
  background: linear-gradient(135deg, rgb(30, 73, 226), rgb(0, 51, 141));
}

.function-card.primary::before {
  background: white;
}

.function-icon {
  color: rgb(0, 51, 141);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: rgb(229, 229, 229);
  border-radius: 50%;
  transition: all 0.4s ease;
  transform: scale(1);
}

.function-card:hover .function-icon {
  transform: scale(1.1) rotate(5deg);
  background: linear-gradient(135deg, rgb(172, 234, 255), rgb(118, 210, 255));
  color: rgb(0, 51, 141);
  box-shadow: 0 8px 20px rgba(0, 51, 141, 0.2);
}

.function-card.primary .function-icon {
  color: white;
}

.function-card h3 {
  font-size: 1.3rem;
  color: rgb(51, 51, 51);
  margin-bottom: 0.5rem;
  font-weight: 600;
  transition: color 0.3s ease;
}

.function-card:hover h3 {
  color: rgb(0, 51, 141);
}

.function-card.primary h3 {
  color: white;
}

.function-card p {
  color: rgb(102, 102, 102);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.function-card.primary p {
  color: rgba(255,255,255,0.9);
}

.function-action {
  display: flex;
  justify-content: flex-end;
}

.function-action span {
  color: rgb(0, 51, 141);
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
}

.function-card:hover .function-action span {
  color: rgb(30, 73, 226);
  font-weight: 700;
  transform: translateX(5px);
}

.function-action span::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, rgb(0, 51, 141), rgb(30, 73, 226));
  transition: width 0.3s ease;
}

.function-card:hover .function-action span::after {
  width: 100%;
}

.function-card.primary .function-action span {
  color: white;
}

.function-card:hover .function-action span {
  transform: translateX(5px);
}

/* Recent Projects */
.recent-projects {
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.section-header h2 {
  font-size: 1.5rem;
  color: rgb(51, 51, 51);
  margin: 0;
  font-weight: 600;
}

.view-all-btn {
  background: rgb(0, 51, 141);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s;
}

.view-all-btn:hover {
  background: #002a75;
  transform: translateY(-1px);
}

.projects-table {
  overflow-x: auto;
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 80px 120px;
  gap: 1rem;
  padding: 1rem;
  background: rgb(229, 229, 229);
  border-radius: 8px;
  font-weight: 600;
  color: rgb(102, 102, 102);
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 80px 120px;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
  transition: background 0.3s;
}

.table-row:hover {
  background: rgb(229, 229, 229);
}

.project-name {
  font-weight: 600;
  color: rgb(51, 51, 51);
}

.sector {
  color: rgb(102, 102, 102);
}

.stage {
  padding: 0.25rem 0.75rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
}

.stage.implementation {
  background: #cce5ff;
  color: #004085;
}

.stage.feasibility {
  background: #d4edda;
  color: #155724;
}

.stage.concept {
  background: #fff3cd;
  color: #856404;
}

.stage.pre-feasibility {
  background: #e2e3e5;
  color: #383d41;
}

.stage.procurement {
  background: #f8d7da;
  color: #721c24;
}

.date {
  color: rgb(102, 102, 102);
  font-size: 0.9rem;
}

.score {
  font-weight: 600;
  color: rgb(0, 51, 141);
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 600;
  transition: all 0.3s;
}

.action-btn.edit {
  background: #fff3cd;
  color: #856404;
}

.action-btn.edit:hover {
  background: #ffeaa7;
  transform: translateY(-1px);
}

.action-btn.view {
  background: #cce5ff;
  color: #004085;
}

.action-btn.view:hover {
  background: #99d3ff;
  transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .functions-grid {
    grid-template-columns: 1fr;
  }
  
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .table-header span,
  .table-row span,
  .table-row div {
    text-align: left;
    padding: 0.25rem 0;
  }
}
</style>